// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1FRWh","right":"Footer_right__2gLk6","buttons":"Footer_buttons__3sS-d"};